import * as React from "react"
import { Checkbox as BaseCheckbox } from "@base-ui/react/checkbox"
import { Check, Minus } from "lucide-react"
import { cn } from "@lib/cn"

export interface CheckboxProps
  extends React.ComponentPropsWithoutRef<typeof BaseCheckbox.Root> {
  size?: "sm" | "md"
}

export const Checkbox = React.forwardRef<HTMLButtonElement, CheckboxProps>(
  ({ className, size = "md", ...props }, ref) => (
    <BaseCheckbox.Root
      ref={ref}
      className={cn(
        "group inline-flex shrink-0 items-center justify-center rounded-sm border outline-none",
        "border-cloverhound-gray-400 bg-white dark:border-cloverhound-gray-700 dark:bg-cloverhound-gray-900",
        "transition-colors duration-quick ease-out-quad motion-reduce:transition-none",
        "hover:border-cloverhound-gray-600 dark:hover:border-cloverhound-gray-500",
        "focus-visible:ring-2 focus-visible:ring-cloverhound-indigo-500 focus-visible:ring-offset-2",
        "focus-visible:ring-offset-cloverhound-gray-50 dark:focus-visible:ring-offset-cloverhound-gray-950",
        "data-[checked]:bg-cloverhound-indigo-600 data-[checked]:border-cloverhound-indigo-600 data-[checked]:text-white",
        "data-[indeterminate]:bg-cloverhound-indigo-600 data-[indeterminate]:border-cloverhound-indigo-600 data-[indeterminate]:text-white",
        "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50",
        size === "sm" ? "size-4" : "size-[18px]",
        className,
      )}
      {...props}
    >
      <BaseCheckbox.Indicator className="flex items-center justify-center">
        <Check
          className={cn(
            "group-data-[indeterminate]:hidden",
            size === "sm" ? "size-3" : "size-3.5",
          )}
          aria-hidden="true"
        />
        <Minus
          className={cn(
            "hidden group-data-[indeterminate]:block",
            size === "sm" ? "size-3" : "size-3.5",
          )}
          aria-hidden="true"
        />
      </BaseCheckbox.Indicator>
    </BaseCheckbox.Root>
  ),
)
Checkbox.displayName = "Checkbox"
